<template>
  <div class="chart-container">
    <div
      @touchstart="touchStart($event)"
      @touchmove="touchMove($event)"
      @touchend="touchEnd($event)"
      id="chart">
    </div>
    <div class="title">
      <span class="heng red-bg"></span>
      <span class="red-text">融资余额:</span>
      <span class="red-text" style="margin-right:.2rem">{{ subTitle[0][0].value }}</span>
      <span class="heng green-bg"></span>
      <span class="green-text">融券余额: </span>
      <span class="green-text">{{ subTitle[0][1].value }}</span>
    </div>
  </div>
</template>
<script>
import rzrq from '@/api/rzrq'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'
import echarts from 'echarts'

export default {
  props: {
    tab: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      subtab: 0,
      subData: {
        'sh': {},
        'sz': {},
        'both': {}
      },
      canScroll: true,
      subApis: ['queryFinaSecuLineChart', 'queryFinaSecuRatioLineChart', 'queryFinaSecuTradingValueLineChart'],
      subTitle: [
        [
          {
            title: '融资余额',
            value: '-',
            type: '',
            unit: '亿'
          },
          {
            title: '融券余额',
            value: '-',
            type: '',
            unit: '亿'
          }
        ],
        [{title: '融资余额占流通市值比', value: '-'}],
        [{title: '融资融券余额', value: '-', type: '', unit: '亿'}],
      ]
    }
  },
  watch: {
    tab(val) {
      this.getChartsData(val)
      if(this.chart) {
        this.chart.dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: 'leave'
        })
      }
    },
    canScroll(val) {
      if(val) {
        document.querySelector('#app').removeEventListener('touchmove', this.forbiddenScroll, false)
        //this.handleTip({show: val})
      } else {
        document.querySelector('#app').addEventListener('touchmove', this.forbiddenScroll, false)
      }
    }
  },
  async mounted() {
    this.chart = echarts.init(document.getElementById('chart'))
    await this.getChartsData('both')
    
  },
  methods: {
    async getChartsData(tab) {
      const tabdata = this.subData[tab][this.subtab]
      if(tabdata && tabdata.length) {
        this.renderChart()
        this.handleTip(tabdata[0].length - 1)
        return
      }
      const url = rzrq[this.subApis[this.subtab]]
      const params = {market: tab}
      const data = await request.get({url, params})
      let series0 = []
      let series1 = []
      let time = []
      if(this.subtab === 0) {
        data.map(item => {
          series0.push(item.FinanceValue)
          series1.push(item.SecurityValue)
          time.push(Utils.getDateStringForLong(item.TradingDay))
        })
      }
      if(this.subtab === 1) {
        data.map(item => {
          series0.push(Utils.formatUnit(item.Ratio, -2))
          time.push(Utils.getDateStringForLong(item.TradingDay))
        })
        series1 = null
      }
      if(this.subtab === 2) {
        data.map(item => {
          series0.push(item.FinanceSecuDiff)
          time.push(Utils.getDateStringForLong(item.TradingDay))
        })
        series1 = null
      }
      this.subData[tab][this.subtab] = [series0, series1, time]
      this.renderChart()
      this.handleTip(data.length-1)
    },

    getSubTitleType(arr, index) {
      if(index === 0
        || arr[index] - arr[index - 1] === 0) return ''
      if(arr[index] - arr[index - 1] > 0) return '↑'
      if(arr[index] - arr[index - 1] < 0) return '↓'
    },
    
    handleTip(index) {
      this.subTitle[this.subtab].forEach((item, i) => {
        const arr = this.subData[this.tab][this.subtab][i]
        item.value = arr[index]
        if(this.subtab === 0 || this.subtab === 2) {
          item.value += item.unit
          item.type = this.getSubTitleType(arr, index)
        }
        if(this.subtab === 1) {
          item.value = item.value + '%'
        }
      });
    },

    renderChart() {
      if(!this.subData[this.tab][this.subtab]) return
      let vm = this
      let option = {
        grid: {
          left: 60,
          right: 40,
          bottom: 25,
          top: 10,
          show: false,
          borderColor: '#cccccc'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            snap: false
          },
          formatter () {
            return ''
          }
        },
        axisPointer: {
          lineStyle: {
            type: 'dashed'
          }
        },
        xAxis: {
          show: true,
          type: 'category',
          nameTextStyle: {
            color: '#666',
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              width: 1,
              color: '#B4B4B4'
            }
          },
          axisPointer: {
            label: {
              formatter (val) {
                vm.handleTip(val.seriesData[0].dataIndex)
                return val.value
              }
            }
          },
          axisLabel: {
            show: true,
            interval: function (index, value) {
              const multiple = 150
              if(index % multiple === 0) {
                return true
              }
            }
          },
          lineStyle: {
            width: 1
          },
          data: vm.subData[vm.tab][vm.subtab][2]
        },
        yAxis: [{
          show: true,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: '#b4b4b4'
            }
          },
          type: 'value'
        }, {
          show: true,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: '#B4B4B4'
            }
          },
          type: 'value'
        }],
        series: [
          {
            data: vm.subData[vm.tab][vm.subtab][0],
            name: '融资',
            yAxisIndex: 0,
            symbol: 'none',
            type: 'line',
            lineStyle: {
              color: '#D4332F',
              width: 1
            }
          },
          {
            data: vm.subData[vm.tab][vm.subtab][1],
            name: '融券',
            yAxisIndex: 1,
            symbol: 'none',
            type: 'line',
            lineStyle: {
              color: '#258D01',
              width: 1
            }
          }
        ]
      }
      this.chart.setOption(option)
      this.chart.resize()
    },
    forbiddenScroll(e) {
      e.preventDefault()
    },

    touchStart(e) {
      this.canScroll = false
    },
    touchMove(e) {
      if(this.canScroll) return this.touchEnd()
    },
    touchEnd() {
      this.canScroll = true
    },
  },
}
</script>
<style lang="stylus" scoped>
  #chart 
    height 1.2rem
    width 100%
  .chart-container
    background #ffffff
  .heng
    display inline-block
    height .01rem
    width .1rem
    border-radius .01rem
    margin-right .04rem
  .red-bg
    background #F43737
    margin-left .4rem
  .green-bg
    background #1BAA3C
  .red-text
    color #F43737
    margin-right .08rem
  .green-text
    color #1BAA3C
    margin-right .08rem
  .title
    display flex
    align-items center
    padding .05rem 0 .12rem 0
</style>